<template>
  <div class="group-detail">
    <h1 class="common__main-title">Unsent Comment</h1>
    <div>
      <div class="common__sub-title">Details</div>
      <TutorInfo :tutor="tutor"/>
      <div class="common__main-contener mb-4">
        <div class="common__main-content bg-white">
          <div class="detail-table">
            <div>
              <div class="detail__item-title">Lesson Date Time</div>
              <p class="detail__item">
                {{ deadline && deadline.lesson.datetime.format('YYYY/MM/DD') }}
              </p>
            </div>
            <template v-if="deadline && deadline.type === DeadlineType.classRecord">
              <div v-for="student of deadline.students" :key="student.id">
                <b-row v-for="point of student.points" :key="point.rubricId">
                  <b-col class="detail__item-title">{{ point.name }}({{ student.name }})</b-col>
                  <b-col class="detail__item">{{ point.description }}</b-col>
                </b-row>
              </div>
            </template>
            <div v-if="deadline && deadline.type === DeadlineType.classRecord">
              <div class="detail__item-title">Comment</div>
              <p class="detail__item">{{ deadline.lesson.comment | empty }}</p>
            </div>
            <template v-if="deadline && deadline.type === DeadlineType.frs">
              <div v-for="student of deadline.students" :key="student.id">
                <div class="detail__item-title">Comment({{ student.name }})</div>
                <p class="detail__item">{{ student.comment | empty }}</p>
              </div>
            </template>
            <div>
              <div class="detail__item-title">Period</div>
              <p  class="detail__item">{{ deadline && deadline.lesson.period }}</p>
            </div>
            <div>
              <div class="detail__item-title">Level</div>
              <p class="detail__item">{{ deadline && deadline.lesson.level.code }}</p>
            </div>
            <div>
              <div class="detail__item-title">Student</div>
              <div class="detail__item mb-0">
                <div
                  v-for="student of deadline && deadline.students"
                  :key="student.index"
                  class="student"
                >
                  <router-link :to="{name:'StudentDetail', params: {id: student.id}}" class="mr-3">
                    {{ student.name }}
                  </router-link>
                  <div class="grade">WeTEC:{{ student.wetecTotalScore }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="common__button-container">
      <b-button
        pill
        variant="secondary"
        :to="{name:'UnfinishedTasks'}"
      >
        Back
      </b-button>
    </div>
  </div>
</template>

<script lang='ts'>
import Vue from 'vue'
import TutorInfo from '@/components/parts/TutorInfo.vue'
import { Deadline, DeadlineType } from '@/store/deadlines/types'
import { Tutor } from '@/store/tutors/types';

export default Vue.extend({
  components: {
    TutorInfo,
  },

  data: (): {
    DeadlineType: typeof DeadlineType,
    isLoading: boolean,
  } => ({
    DeadlineType,
    isLoading: false,
  }),

  filters: {
    empty: (text: string|null): string => text || '----------------',
  },

  computed: {
    deadline(): Deadline|null {
      return this.$store.getters.getDeadlineById(this.$route.params.deadlineId)
    },
    tutor(): Tutor|null {
      return this.$store.getters.findTutorById(this.deadline?.tutor.tutorId)
    },
  },

  async created() {
    this.isLoading = true;
    try {
      await this.$store.dispatch('getDeadline', {
        id: this.$route.params.deadlineId,
      })
      await this.$store.dispatch('getTutor', {
        tutorId: this.deadline?.tutor.tutorId,
      })
    } catch (error: any) {
      const message = error.response?.data?.message || error
      await this.$bvModal.msgBoxOk(`Error - ${message}`)
      this.$router.push({ name: 'UnfinishedTasks' })
    }
    this.isLoading = false
  },

});
</script>

<style scoped>
.detail-table {
  width:100%;
}

.detail__item-title {
  line-height: 14px;
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  margin-bottom:10px;
}

.detail__item-title::before {
  content: '●';
  color: #F8CBAD;
  margin-right: 5px;
  vertical-align: text-top;
}

.detail__item {
  line-height: 14px;
  font-size: 14px;
  margin-bottom:30px;
  padding-left:20px;
}

.student {
  margin-bottom:10px;
  align-items: center;
  display: flex;
}

.tutor-box {
  display: flex;
  align-items: center;
}

.grade {
  padding: 5px 10px ;
  background: #FFD966;
  border-radius: 30px;
  cursor: pointer;
  text-decoration: none;
}

.tutor-name {
  display: flex;
  align-items: center;
  margin-right:20px;
}

.tutor-info {
  margin-right:10px;
  height: 20px;
  display: flex;
  align-items: center;
  padding: 5px 10px ;
  background: #638ACF;
  color: #fff;
  border-radius: 30px;
  text-decoration: none;
}

.substitute-time {
  margin-right:10px;
  height: 20px;
  display: flex;
  align-items: center;
  padding: 5px 10px ;
  background: #F38181;
  color: #fff;
  border-radius: 30px;
  text-decoration: none;
}

.tutor-button {
  background: #D84C60;
  border: 3px solid #D84C60;
  display: block;
  text-decoration: none;
  color: #fff;
  width: 160px;
  font-size:15px;
  line-height: 15px;
  text-align: center;
  padding: 10px;
  border-radius: 20px;
  cursor: pointer;
  transition: .2s;
  user-select: none;
  margin-top:20px;
}

.tutor-button:hover {
  background: #fff;
  color:#D84C60;
}
</style>
